import { Box, Button, Typography } from 'components/Material/index'
import TuneOutlinedIcon from '@mui/icons-material/TuneOutlined'
import useTextStyles from 'styles/useTextStyles'

interface ApplyFiltersProps {
  onClick: () => void
  variant?: 'text' | 'outlined' | 'contained'
  buttonClassName?: string
}

export function ApplyFiltersButton({ onClick, variant = 'outlined' }: ApplyFiltersProps) {
  return (
    <Button
      className={`h-fit w-150px p-[10px] ${variant === 'outlined' ? 'border-[#79747E]' : ''}`}
      variant={variant}
      onClick={onClick}
    >
      <Box className="flex justify-center items-center gap-2">
        <TuneOutlinedIcon className="w-[18px] h-[18px]" />
        <Typography sx={{ ...useTextStyles.labelLarge, textTransform: 'none' }}>
          Aplicar filtros
        </Typography>
      </Box>
    </Button>
  )
}
